export default __webpack_public_path__ + "static/media/onboard.5cba4d34.svg";